import { Component, Input } from '@angular/core';
import { FiltersComponent } from 'src/app/common/filters.component';

@Component({
	selector: 'app-products-list-filters',
	templateUrl: './products-list-filters.component.html',
	styleUrls: ['./products-list-filters.component.css'],
})
export class ProductsListFiltersComponent extends FiltersComponent {
	filters = {
		product_kind__id__in: null,
		tags__id__in: null,
		status__in: null,
		location__id__in: null,
	};
	protected filtersDefinition = {
		product_kind__id__in: {
			type: 'number',
			isArray: true,
		},
		tags__id__in: {
			type: 'number',
			isArray: true,
		},
		status__in: {
			type: 'string',
			isArray: true,
		},
		location__id__in: {
			type: 'number',
			isArray: true,
		},
	};

	statusSet: Array<any> = [
		{ value: 'D', name: 'Szkic' },
		{ value: 'P', name: 'Opublikowany' },
		{ value: 'A', name: 'Zarchiwizowany' },
	];

	@Input() type: Array<any>;
	@Input() allTags: Array<any>;
	@Input() status: boolean;
	@Input() location: Array<any>;
}
